export const INIT_TOOLTIP = 'INIT_TOOLTIP';
export const SWITCH_TOOLTIP = 'SWITCH_TOOLTIP';
export const UPDATE_TOOLTIP = 'UPDATE_TOOLTIP';

export const initTooltipAction = (text, tooltipID, tooltipName, showInMobile) => (dispatch) => {
    dispatch({
        type: INIT_TOOLTIP,
        payload: {
            id: tooltipID,
            name: tooltipName,
            text,
            showInMobile
        }
    });
};

export const updateTooltipAction = (tooltipName, text) => (dispatch) => {
    dispatch({
        type: UPDATE_TOOLTIP,
        payload: {
            name: tooltipName,
            text
        }
    });
};

export const switchTooltipAction = tooltipID => (dispatch) => {
    dispatch({ type: SWITCH_TOOLTIP, payload: tooltipID });
};
